import React, { useEffect, useState } from 'react';
import moment from 'moment';

interface TimeSelector {
  selectedIntervals?: [string, string][];
  onChange: (selected: [string, string][]) => void;
}

const TimeSelector: React.FC<TimeSelector> = ({ selectedIntervals = [], onChange }) => {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  useEffect(() => {
    setSelected(new Set(selectedIntervals.map((pair) => pair.join('-'))));
  }, [selectedIntervals]);

  const generateTimeIntervals = (): {
    value: [string, string];
    label: string;
    id: string;
  }[] => {
    const intervals = [];
    let current = moment('08:00', 'HH:mm');
    const end = moment('20:00', 'HH:mm');

    while (current.isBefore(end)) {
      const startStr = current.format('HH:mm');
      const endStr = current.clone().add(15, 'minutes').format('HH:mm');
      const label = `${current.format('h:mm A')} - ${current
        .clone()
        .add(15, 'minutes')
        .format('h:mm A')}`;
      const id = `${startStr}-${endStr}`;
      intervals.push({
        value: [startStr, endStr] as [string, string],
        label,
        id,
      });
      current.add(15, 'minutes');
    }

    return intervals;
  };

  const handleCheckboxChange = (id: string, value: [string, string]) => {
    const updated = new Set(selected);
    if (updated.has(id)) {
      updated.delete(id);
    } else {
      updated.add(id);
    }
    setSelected(updated);
    const result = Array.from(updated).map(
      (intervalStr) => intervalStr.split('-') as [string, string],
    );
    onChange(result);
  };

  const intervals = generateTimeIntervals();

  const allSelected = intervals.length > 0 && selected.size === intervals.length;

  const handleAllChange = () => {
    if (allSelected) {
      setSelected(new Set());
      onChange([]);
      return;
    }
    const updated = new Set(intervals.map(({ id }) => id));
    setSelected(updated);
    onChange(intervals.map(({ value }) => value));
  };

  return (
    <div>
      <div>
        <label>
          <input
            type='checkbox'
            checked={allSelected}
            onChange={handleAllChange}
            style={{ marginRight: '8px' }}
          />
          <strong>Todos</strong>
        </label>
      </div>
      {intervals.map(({ value, label, id }) => (
        <div key={id}>
          <label>
            <input
              type='checkbox'
              checked={selected.has(id)}
              onChange={() => handleCheckboxChange(id, value)}
              style={{ marginRight: '8px' }}
            />
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default TimeSelector;
